import React, {useRef} from "react";
import {SwiperSlide} from "swiper/react";
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import Slider from "react-slick";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import "./selectableslider.scss";

export interface ISelectableSlider {
    sliderItems: JSX.Element[]
}

export default function SelectableSlider({sliderItems}: ISelectableSlider) {
    const sliderRef = useRef<Slider>(null);
    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "center",
        centerMode: true,
        centerPadding: "40px",
        slidesPerRow: 4,
        rows: 2,
        initialSlide:0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    rows: 2,
                    slidesPerRow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 1,
                    slidesPerRow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 1,
                    slidesPerRow: 1,
                }
            }
        ]
    };
    return (
        <div className="Selectable-Slider">
            <div className="Selectable-Slider-Item-Preview">
                <div className="bg-white rounded-circle p-3 d-inline-block mt-2">
                    <img src={require("../../../assets/images/icons/TVSpeaker.svg").default} alt=""
                         className="img-fluid" style={{width: '40px'}}/>
                </div>
                <h4>تبلیغات ویدیوئی</h4>
                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و
                    متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
            </div>
            <div className="Selectable-Slider-Box">
                <div className="Navigation-Buttons">
                    <div onClick={() => {
                        sliderRef?.current?.slickNext();
                    }} className="Navigate-Right">
                        <img src={require("../../../assets/images/icons/RightArrow.svg").default} alt="" className=""/>
                    </div>
                    <div onClick={() => {
                        sliderRef?.current?.slickPrev();
                    }} className="Navigate-Left">
                        <img src={require("../../../assets/images/icons/LeftArrow.svg").default} alt="" className=""/>
                    </div>
                </div>
                <Slider ref={sliderRef} {...settings}>
                    {
                        sliderItems.map((item, index) => {
                            return <SwiperSlide key={index}>{item}</SwiperSlide>
                        })
                    }
                </Slider>
            </div>
        </div>
    );
}
